import React from "react";

import { css } from "@emotion/core";
import { isFunction } from "lodash";

import { Alert, Colors, Margin } from "@zapier/design-system";

import { OverdueInvoice } from "../../../types";
import { OverdueInvoiceAlert } from "../PaymentMethodsSection/OverdueInvoiceAlert";

type Props = {
  isEditing?: boolean;
  renderAside?: () => JSX.Element | null;
  renderLabel?: () => JSX.Element | null;
  overdueInvoice?: OverdueInvoice;
  showChangeSuccessMessage: boolean;
  onHideSuccessMessage: () => void;
};

const containerCss = css`
  border: 1px solid ${Colors.neutral400};
  border-radius: 3px;
  padding: 20px;
  position: relative;
`;

const headerCss = css`
  align-items: start;
  display: grid;
  grid-template-columns: 1fr auto;
  min-height: 40px;
  @media screen and (max-width: 769px) {
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
  }
`;

const headerLabelCss = {
  display: "flex",
  alignItems: "center",
  "> *": {
    marginRight: 10,
  },
};

const sectionCss = {
  marginTop: 20,
};

const PaymentMethod: React.FC<Props> = props => {
  return (
    <section css={containerCss}>
      {props.showChangeSuccessMessage && (
        <Margin margin="0 0 20px 0">
          <Alert onDismiss={props.onHideSuccessMessage} type="success">
            Payment details have been saved.
          </Alert>
        </Margin>
      )}

      {Boolean(props.overdueInvoice) && (
        <Margin margin="0 0 20px 0">
          <OverdueInvoiceAlert
            failureReason={props.overdueInvoice?.failureReason}
          />
        </Margin>
      )}

      <header css={headerCss}>
        <div css={headerLabelCss}>
          {isFunction(props.renderLabel) && props.renderLabel()}
        </div>
        {isFunction(props.renderAside) && props.renderAside()}
      </header>
      {props.isEditing && props.children && (
        <div css={sectionCss}>{props.children}</div>
      )}
    </section>
  );
};

export default PaymentMethod;
